import {
  CheckOutlined,
  CloseOutlined,
  SettingOutlined,
  WarningOutlined,
} from "@ant-design/icons";
import { Button, Rate, Drawer } from "antd";
import axios from "axios";
import moment from "moment";
import PropTypes from "prop-types";
import React, { ReactElement, useCallback, useEffect, useState } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { getParamValue } from "../../../utils";
import { authenticateToken } from "../../../utils/auth";
import { responseNotification } from "../../../utils/notify";
import { useLocation } from "react-router-dom";
import { useHistory, useParams } from "react-router";
import _ from "lodash";
import HubLayout from "../Layout";

import ShopHeader from "../Layout/topHeader";
import { useDispatch } from "react-redux";
import { SET_SHOP_INFO } from "../../../redux/auth/authType";
import AddShop from "../../Shops/AddShop";

const MerchantShopDetails = (
  { onCloseMethod, params }: any,
  props
): ReactElement => {
  const [singleShopInfo, setSingleShopInfo] = useState({
    loading: false,
    data: null,
  });
  const [categoryData, setCategoryData] = useState({
    loading: false,
    list: null,
  });
  const [selectedShopForEdit, setSelectedShopForEdit] = useState(undefined);
  const [visible, setVisible] = useState(undefined);
  const route = useParams();
  const history = useHistory();
  const loc = useLocation();
  const page = getParamValue(loc.search, "page");
  const dispatch = useDispatch();

  const fetchShopDetails = useCallback((getShopId) => {
    if (getShopId) {
      try {
        setSingleShopInfo({ loading: true, data: undefined });
        axios
          .get(
            `${process.env.REACT_APP_CATALOG_READER_API}/shop/details?shopId=${getShopId}`,
            {
              headers: {
                Authorization: `Bearer ${authenticateToken()}`,
                "Content-Type": "application/json",
              },
            }
          )
          .then((data) => {
            if (data.status === 200) {
              setSingleShopInfo({
                loading: false,
                data: data?.data?.shop,
              });
              dispatch({
                type: SET_SHOP_INFO,
                payload: {
                  shopInfo: {
                    id: data?.data?.shop?.name,
                    name: data?.data?.shop?.name,
                    contactNumber: data?.data?.shop?.contactNumber,
                    logo: data?.data?.shop?.logo,
                    banner: data?.data?.shop?.banner,
                    rating: data?.data?.shop?.rating,
                    status: data?.data?.shop?.status,
                  },
                },
              });
            } else {
              setSingleShopInfo({ loading: false, data: null });
              responseNotification(
                data.statusText || "something went wrong",
                "error"
              );
            }
          })
          .catch((err) => {
            setSingleShopInfo({ loading: false, data: null });

            console.log(err);
          });
      } catch (error) {
        setSingleShopInfo({ loading: false, data: null });

        console.log(error, "error");
      }
    }
  }, []);

  // useEffect(() => {
  //   fetchShopDetails(selectedShop);
  // }, [fetchShopDetails, selectedShop]);

  useEffect(() => {
    fetchShopDetails((route as any)?.shopId);
  }, [fetchShopDetails, (route as any)?.shopId]);

  const getCategoryOptions = useCallback(
    async (value) => {
      setCategoryData({ loading: true, list: null });
      const encodedUri = `${process.env.REACT_APP_CATALOG_READER_API}`;
      axios
        .get(
          `${encodedUri}/category/search?page=0&limit=20&isParent=true&type=${singleShopInfo?.data?.type}&key=${value}`,
          {
            headers: {
              Authorization: `Bearer ${authenticateToken()}`,
            },
          }
        )
        .then((res) => {
          setCategoryData({ loading: false, list: res.data });
        })
        .catch((err) => {
          setCategoryData({ loading: false, list: [] });
          console.error("Category: Error", err);
        });
    },
    [singleShopInfo?.data?.type]
  );

  useEffect(() => {
    if (singleShopInfo?.data?.type) {
      getCategoryOptions("");
    }
  }, [getCategoryOptions]);

  useEffect(() => {
    if (visible) {
      setSelectedShopForEdit(undefined);
    }
  }, [selectedShopForEdit]);

  useEffect(() => {
    setSelectedShopForEdit(undefined);
  }, [visible]);

  const onClose = () => {
    setSelectedShopForEdit(null);
    fetchShopDetails((route as any)?.merchantId);
  };

  const shop = singleShopInfo?.data;

  return (
    <React.Fragment>
      <HubLayout merchantId={(route as any)?.merchantId as string}>
        <div className="bg-white">
          <ShopHeader
            leftarea={"Shop Information"}
            rightarea={
              <Button
                onClick={() => history.push(`/shops/${shop?.id}/details`)}
                target="_blank"
              >
                <SettingOutlined /> Manage Shop
              </Button>
            }
          />
          <div className=""></div>
          <div className="details-area">
            <div className="pt-4">
              <div className="inner-body">
                <div className="single">
                  <span className="info-name">Shop Name</span>
                  <span className="info-desc">{shop?.name}</span>
                </div>

                <div className="single">
                  <span className="info-name">Shop ID</span>
                  <span className="info-desc">{shop?.id}</span>
                </div>

                <div className="single">
                  <span className="info-name">Shop Slug</span>
                  <span className="info-desc">{shop?.slug}</span>
                </div>

                <div className="single">
                  <span className="info-name">Delivery Conition</span>
                  <span className="info-desc">
                    {shop?.isFreeDelivery === true
                      ? "Free Delivery"
                      : "Paid Delivery"}
                  </span>
                </div>

                <div className="single">
                  <span className="info-name">Base Delivery Charge</span>
                  <span className="info-desc">{shop?.baseDeliveryCharge}</span>
                </div>

                <div className="single">
                  <span className="info-name">Prepare Time</span>
                  <span className="info-desc">{shop?.prepareTime}</span>
                </div>

                <div className="single">
                  <span className="info-name">Contact Number</span>
                  <span className="info-desc">{shop?.contactNumber}</span>
                </div>

                <div className="single">
                  <span className="info-name">Mobile Number</span>
                  <span className="info-desc">{shop?.mobileNumber}</span>
                </div>

                <div className="single">
                  <span className="info-name">Email Address</span>
                  <span className="info-desc">{shop?.email}</span>
                </div>

                <div className="single">
                  <span className="info-name">Owner Id</span>
                  <span className="info-desc">{shop?.ownerId}</span>
                </div>

                <div className="single">
                  <span className="info-name">Address</span>
                  <span className="info-desc">{shop?.address}</span>
                </div>

                <div className="single">
                  <span className="info-name">Area</span>
                  <span className="info-desc">{shop?.area}</span>
                </div>

                <div className="single">
                  <span className="info-name">City</span>
                  <span className="info-desc">{shop?.city}</span>
                </div>

                <div className="single">
                  <span className="info-name">Country</span>
                  <span className="info-desc">{shop?.country}</span>
                </div>

                <div className="single">
                  <span className="info-name">Shop Type</span>
                  <span className="info-desc">
                    {shop?.type?.replace("_", " ")}
                  </span>
                </div>

                <div className="single">
                  <span className="info-name">Status</span>
                  <div className="info-desc">
                    <span
                      className={`radius-btn text-uppercase ${shop?.status?.toLowerCase()}-btn`}
                    >
                      {shop?.status?.toUpperCase() === "OPEN" ? (
                        <CheckOutlined className="mr-1" />
                      ) : shop?.status?.toUpperCase() === "BUSY" ? (
                        <WarningOutlined className="mr-1" />
                      ) : (
                        <CloseOutlined className="mr-1" />
                      )}
                      {shop?.status?.split("_").join(" ")}
                    </span>
                  </div>
                </div>

                <div className="single">
                  <span className="info-name">Rattings</span>
                  <span className="info-desc">
                    <Rate value={shop?.rating || 0} disabled />
                    <small className="ml-1">({shop?.numberOfRating})</small>
                  </span>
                </div>

                <div className="single">
                  <span className="info-name">Joining Date</span>
                  <span className="info-desc">
                    {moment(shop?.createdAt).format("lll")}
                  </span>
                </div>

                <div className="single">
                  <span className="info-name">Keywords</span>
                  <span className="info-desc">{shop?.keywords}</span>
                </div>

                <div className="single">
                  <span className="info-name">Description</span>
                  <span className="info-desc">{shop?.description}</span>
                </div>
              </div>

              <h6 className="mt-5 title" style={{ width: "98%" }}>
                Bank Details
              </h6>
              <div className="inner-body">
                <div className="single">
                  <span className="info-name">Account Name</span>
                  <span className="info-desc">
                    {shop?.bankInfo?.accountName}
                  </span>
                </div>

                <div className="single">
                  <span className="info-name">Account Number</span>
                  <span className="info-desc">
                    {shop?.bankInfo?.accountNumber}
                  </span>
                </div>

                <div className="single">
                  <span className="info-name">Bank Name</span>
                  <span className="info-desc">{shop?.bankInfo?.bankName}</span>
                </div>

                <div className="single">
                  <span className="info-name">Branch Name</span>
                  <span className="info-desc">
                    {shop?.bankInfo?.branchName}
                  </span>
                </div>

                <div className="single">
                  <span className="info-name">Routing Number</span>
                  <span className="info-desc">
                    {shop?.bankInfo?.routingNumber}
                  </span>
                </div>

                <div className="single">
                  <span className="info-name">Swift Code</span>
                  <span className="info-desc">{shop?.bankInfo?.swiftCode}</span>
                </div>
              </div>
            </div>
          </div>

          <Drawer
            title={selectedShopForEdit ? "Edit Shop" : ""}
            width={900}
            onClose={() => {
              setSelectedShopForEdit(null);
            }}
            visible={selectedShopForEdit}
            bodyStyle={{ paddingBottom: 80 }}
            footer={
              <div
                style={{
                  textAlign: "right",
                }}
              ></div>
            }
          >
            {selectedShopForEdit ? (
              <AddShop shopSlug={selectedShopForEdit} onCloseMethod={onClose} />
            ) : undefined}
          </Drawer>
        </div>
      </HubLayout>
    </React.Fragment>
  );
};
MerchantShopDetails.propTypes = {
  match: PropTypes.object,
  params: PropTypes.object,
};
export default MerchantShopDetails;
